import { render, staticRenderFns } from "./OrderQuota.vue?vue&type=template&id=e7dd1f04&scoped=true&"
import script from "./OrderQuota.vue?vue&type=script&lang=js&"
export * from "./OrderQuota.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuota.vue?vue&type=style&index=0&id=e7dd1f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dd1f04",
  null
  
)

/* custom blocks */
import block0 from "./OrderQuota.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./OrderQuota.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VTextField})
